import adminApiFetch from './apiService';

const orderTemplateService = {
  // Get order templates list (for search)
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.limit) queryParams.append('limit', params.limit);

    const res = await adminApiFetch(`order_templates?${queryParams.toString()}`, {
      method: 'GET'
    });
    return res.json();
  },

  // Get order templates list (for table)
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('order_templates/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // Get all order template IDs (for filtering)
  getIds: async (params = {}) => {
    const res = await adminApiFetch('order_templates/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // Get single order template
  get: async (id) => {
    const res = await adminApiFetch(`order_templates/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // Get single order template (alias)
  getById: async (id) => {
    return orderTemplateService.get(id);
  },

  // Create order template
  create: async (data) => {
    const res = await adminApiFetch('order_templates', {
      method: 'POST',
      body: { order_template: data }
    });
    return res.json();
  },

  // Update order template
  update: async (id, data) => {
    const res = await adminApiFetch(`order_templates/${id}`, {
      method: 'PUT',
      body: { order_template: data }
    });
    return res.json();
  },

  // Delete order template
  delete: async (id) => {
    const res = await adminApiFetch(`order_templates/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  },

  // Get merchant channels list
  getSalesChannels: async () => {
    const res = await adminApiFetch('sales_channels', {
      method: 'GET'
    });
    const data = await res.json();
    if (data.success && Array.isArray(data.data)) {
      return data.data.map(channel => ({
        label: channel.name,
        value: channel.id
      }));
    }
    return [];
  },

  // Get default liquid template
  getDefaultTemplate: async () => {
    const res = await adminApiFetch('order_templates/default_template', {
      method: 'GET'
    });
    return res.json();
  },

  // Upload PDF and analyze with AI
  analyzePdf: async (formData) => {
    // Note: FormData automatically sets correct Content-Type with boundary
    const res = await adminApiFetch('order_templates/analyze_pdf', {
      method: 'POST',
      body: formData  // FormData will be detected automatically
    });
    return res.json();
  },

  // AI chat for template layout adjustment
  aiChat: async (data) => {
    const res = await adminApiFetch('order_templates/ai_chat', {
      method: 'POST',
      body: data
    });
    return res.json();
  },

  // Get sample reserved barcode area
  getSampleReservedBarcodeArea: async () => {
    const res = await adminApiFetch('order_templates/sample_reserved_barcode_area', {
      method: 'GET'
    });
    return res.json();
  }
};

export { orderTemplateService };
export default orderTemplateService;
